import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, input, OnDestroy, output, viewChild } from '@angular/core';
import { SmartFixUIState } from '../utils/interfaces/bedrock-chat.interface';

@Component({
  selector: 'app-smart-fix-image-hero',
  templateUrl: './smart-fix-image-hero.component.html',
  styleUrls: ['./smart-fix-image-hero.component.scss'],
  imports: [CommonModule],
})
export class SmartFixImageHeroComponent implements AfterViewInit, OnDestroy {
  uiState = input.required<SmartFixUIState>();
  isOnMobile = input<boolean>(false);
  staticHeroOnly = input<boolean>(false);
  transitionComplete = output<void>();
  public SmartFixUIState = SmartFixUIState;

  introVideo = viewChild<ElementRef<HTMLVideoElement>>('introVideo');
  transitionVideo = viewChild<ElementRef<HTMLVideoElement>>('transitionVideo');

  private isDestroyed = false;

  ngAfterViewInit() {
    if (this.staticHeroOnly()) return;
    const smartFixHeroAnimation = this.introVideo()?.nativeElement;
    if (!smartFixHeroAnimation) return;
    smartFixHeroAnimation.src = this.animationSrc('intro');
    this.setCommonVideoProps(smartFixHeroAnimation, true);
    smartFixHeroAnimation.load();
    this.safePlay(smartFixHeroAnimation);
  }

  ngOnDestroy() {
    this.isDestroyed = true;
  }

  playTransition() {
    const smartFixHeroTransitionAnimation = this.transitionVideo()?.nativeElement;
    if (!smartFixHeroTransitionAnimation) return;

    smartFixHeroTransitionAnimation.currentTime = 0;
    smartFixHeroTransitionAnimation.src = this.animationSrc('transition');
    this.setCommonVideoProps(smartFixHeroTransitionAnimation, false);
    this.safePlay(smartFixHeroTransitionAnimation);
  }

  private safePlay(video: HTMLVideoElement) {
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        if (error.name === 'AbortError' || this.isDestroyed) {
          // Ignore AbortError as it's usually caused by the video being removed from the document
          // or a new play() request interrupting the previous one.
          return;
        }
        console.error('Error attempting to play video:', error);
      });
    }
  }

  onVideoEnded() {
    setTimeout(() => {
      this.transitionComplete.emit();
    }, 100);
  }

  animationSrc(type: 'intro' | 'transition'): string {
    const srcBase = '/assets/images/smart-fix-assets/';
    const deviceType = this.isOnMobile() ? 'mobile' : 'desktop';
    return type === 'intro'
      ? `${srcBase}smart-fix-animation-${deviceType}.mp4`
      : `${srcBase}smart-fix-animation-transition-${deviceType}.mp4`;
  }

  setCommonVideoProps(video: HTMLVideoElement, loop = false) {
    video.muted = true;
    video.playsInline = true;
    video.loop = loop;
  }
}
